import React from 'react'
import Box from '@material-ui/core/Box'
import FormSubheader from '../form-subheader'
import AboutYou from '../../form-components/about-you'
import ProfilePhoto from '../../form-components/profile-photo'
import { useCreateProfileFieldStyles } from '../field-styles'

const AboutYouSection = ({ memberProfile }) => {
  const classes = useCreateProfileFieldStyles()

  return (
    <Box className={classes.sectionStack}>
      <Box className={classes.fieldSection}>
        <FormSubheader title="Your details" />
        <AboutYou memberProfile={memberProfile} />
      </Box>
      <Box className={classes.fieldSection}>
        <FormSubheader title="Profile photo" />
        <ProfilePhoto memberProfile={memberProfile} />
      </Box>
    </Box>
  )
}

export default AboutYouSection
